import { find, go, head, html, reject, strMap } from 'fxjs/es';
import { NessLabsConstantS } from '../Constant/module/NessLabsConstantS.js';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import { getSmileIcon } from '../../../Ness/Core/S/Tmpl/icon.js';
import $dataStr from 'fxdom/es/dataStr.js';
import { NessLabsTmplS } from './module/NessLabsTmplS.js';
import { NessLabsS } from '../Function/module/NessLabsS.js';
import { CharacterValidatorS } from '../Function/character.js';

const makeNavButton = (direction) => html`
  <div class="nav-container">
    <button class="nav-btn ${direction}"></button>
  </div>
`;

export const characterInfoHtml = (current_character) => {
  if (!current_character) return;
  const { gc_name, gc_class_name, gc_level, world_name } = current_character;
  return html`
    <div class="info-container">
      <div class="info-container__desc">
        Lv.${gc_level || ''}
        <div class="info-container__desc__server">${world_name}</div>
        <div class="info-container__desc__class">${gc_class_name}</div>
      </div>
      <div class="info-container__name">${gc_name || ''}</div>
      <button class="change_motion">${ET('labs::main::change_button')}${getSmileIcon()}</button>
    </div>
  `;
};

export const characterSeletorListTmpl = (current_character, characters, is_mobile) => {
  if (characters.error) return NessLabsTmplS.errorCharacterMessage();

  const has_no_character = !characters.length || !characters;
  if (has_no_character) {
    return NessLabsTmplS.noCharacterMessage();
  }

  // Sort characters by last login date in descending order
  characters.sort((a, b) => {
    const aDate = a.date_last_login instanceof Date ? a.date_last_login : new Date(a.date_last_login);
    const bDate = b.date_last_login instanceof Date ? b.date_last_login : new Date(b.date_last_login);
    return bDate.getTime() - aDate.getTime();
  });

  return html`
    <div class="character-selection">
      <div class="character-list">
        ${!is_mobile ? makeNavButton('prev') : ''}

        <div class="swiper character-swiper">
          <div class="swiper-wrapper">
            ${strMap((character) => {
              const is_active =
                character.is_selected || character?.maple_image_url === current_character?.maple_image_url;
              return html`
                <div class="swiper-slide">${makeListItem({ character, is_active, has_no_character })}</div>
              `;
            }, characters)}
          </div>
        </div>
        ${UtilS.htmlIf(
          !is_mobile,
          html`
            <div class="labs__main-container__badge__number">
              Total<span class="labs__main-container__badge__number__span">${characters?.length || 0}</span>
            </div>
          `,
        )}
        ${UtilS.htmlIf(!is_mobile, makeNavButton('next'))}
      </div>
    </div>
  `;
};

export const makeListItem = ({ character, is_active, has_no_character }) => {
  const is_invalid = CharacterValidatorS.isInvalidCharacter(character);
  return html` <div class="character-item ${is_active ? 'active' : ''}" data-fx-json="${$dataStr(character)}">
    <canvas
      class="character-thumbnail"
      data-src="${has_no_character
        ? NessLabsConstantS.NO_CHARACTER
        : is_invalid
          ? NessLabsConstantS.DEFAULT_CHARACTER
          : character?.maple_image_url}"
    ></canvas>
  </div>`;
};

export const defaultCharacterImg = ({ is_login }) => {
  return html`<img
    class="labs__main-container__content__not-login"
    alt="maplestory labs"
    src="${NessLabsConstantS.DEFAULT_CHARACTER_WEBP}"
    style="${is_login ? 'display : none' : ''}"
  />`;
};

export const currentCharacterHtml = (current_character) => {
  if (!current_character) return ``;
  const { maple_image_url, selected_motions, avatar_bottom_y_ratio, error_character } = current_character;
  const motioned_image_url = NessLabsS.makeCharactersMotionUrl(maple_image_url, selected_motions);

  return html` <div class="labs__main-container__img-container">
    <canvas
      class="labs__main-container__my-character my-character"
      data-fx-json="${$dataStr(current_character)}"
      data-src="${error_character
        ? NessLabsConstantS.NO_CHARACTER
        : CharacterValidatorS.isInvalidCharacter(current_character)
          ? NessLabsConstantS.DEFAULT_CHARACTER
          : motioned_image_url}"
      data-avatar_bottom_y_ratio=${avatar_bottom_y_ratio}
    ></canvas>
  </div>`;
};

export const labsMainContainer = ({ characters, is_login, is_mobile }) => {
  const current_character = getCurrentCharacter(is_login, characters);
  return html`
    <div class="labs__main-container">
      <img
        src="${NessLabsConstantS.LABS_BG_IMG(is_mobile)}"
        alt="background"
        class="labs__main-container__background-image"
      />
      ${UtilS.htmlIf(
        !is_mobile,
        html` <div class="labs__main-container__logo">
          <img src="${NessLabsConstantS.LOGO}" alt="maplestory labs" />
        </div>`,
      )}
      ${is_login && !characters.error ? NessLabsTmplS.reloadContainer() : ''}
      <div class="labs__main-container__content">
        ${defaultCharacterImg({ is_login })}${is_login ? currentCharacterHtml(current_character) : ''}
        <div class="labs__main-container__settings">
          ${is_login && characters.length ? characterInfoHtml(current_character) : ``}
          ${UtilS.htmlIfElse(
            is_login,
            characterSeletorListTmpl(current_character, characters, is_mobile),
            NessLabsTmplS.loginMessage(),
          )}
        </div>
      </div>
    </div>
  `;
};

const getCurrentCharacter = (is_login, characters) => {
  return is_login
    ? characters?.length
      ? go(
          characters,
          find(({ is_selected }) => is_selected),
          (current) => current || go(characters, reject(CharacterValidatorS.isInvalidCharacter), head),
        )
      : {
          maple_image_url: NessLabsConstantS.NO_CHARACTER,
          error_character: true,
        }
    : {
        maple_image_url: NessLabsConstantS.DEFAULT_CHARACTER,
        error_character: true,
      };
};
